import {
    ValidationResult,
    createValidationResult,
    ValidationFailure,
    createErrorFailure,
    depascalize
} from "sprint-common-web";

import { OrderStatus } from "../../../common/types/OrderStatus";
import { CloudOrderSource } from "../OrderListingItem";
import { MergeOrdersItem } from "./MergeOrdersItem";

export interface MergeOrdersValidationRequest {
    sourceOrder: MergeOrdersItem;
    targetOrder: MergeOrdersItem;
}

export const getMergeOrdersValidationResult = (request: MergeOrdersValidationRequest): ValidationResult => {
    return createValidationResult([
        validateAirlines(request),
        validateOrderSource(request),
        validateSourceOrigin(request.sourceOrder),
        validateTargetOrigin(request.targetOrder),
        validateSourceStatus(request.sourceOrder),
        validateTargetStatus(request.targetOrder)
    ]);
};

const validateAirlines = (request: MergeOrdersValidationRequest): ValidationFailure | void => {
    const { sourceOrder, targetOrder } = request;

    if (sourceOrder.airline !== targetOrder.airline) {
        return createErrorFailure("Airlines vary between orders.");
    }
};

const validateOrderSource = (request: MergeOrdersValidationRequest): ValidationFailure | void => {
    const { sourceOrder, targetOrder } = request;

    if (sourceOrder.source === CloudOrderSource.Shreq || targetOrder.source === CloudOrderSource.Shreq) {
        return createErrorFailure("Orders from Shreq cannot be merged.");
    }
};

const validateSourceOrigin = (sourceOrder: MergeOrdersItem): ValidationFailure | void => {
    if (sourceOrder.buzzId) {
        return createErrorFailure("Source order has to be either manual or imported record.");
    }
};

const validateTargetOrigin = (targetOrder: MergeOrdersItem): ValidationFailure | void => {
    if (!targetOrder.buzzId) {
        return createErrorFailure("Target order has to come from Buzz");
    }
};

const validateSourceStatus = (sourceOrder: MergeOrdersItem): ValidationFailure | void => {
    if (!allowedSourceStatuses.includes(sourceOrder.status)) {
        return createErrorFailure(discardedOrdersInfoMessage);
    }
};

const validateTargetStatus = (targetOrder: MergeOrdersItem): ValidationFailure | void => {
    if (targetOrder.status === OrderStatus.DeliveryCompleted || targetOrder.status === OrderStatus.DeliveryApproved) {
        return createErrorFailure("The target order is being delivered or has already been delivered.");
    }

    if (targetOrder.status === OrderStatus.Overridden) {
        return createErrorFailure("Cannot override already overridden order.");
    }
};

const allowedSourceStatuses = [
    OrderStatus.Approved,
    OrderStatus.Pending,
    OrderStatus.Encoded,
    OrderStatus.DeliveryCompleted
];

const discardedOrdersInfoMessage = `Source order status is other than ${allowedSourceStatuses.map(
    (s) => `'${depascalize(OrderStatus[s])}' `
)}.`;
